import { useState } from "react";
import { toast } from "sonner";
import { startCheckout } from "@/lib/api";

export const CheckoutButton = ({ className = "btn btn-gold", children, testId, style }) => {
  const [busy, setBusy] = useState(false);
  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      const { checkout_url } = await startCheckout();
      window.location.href = checkout_url;
    } catch (err) {
      setBusy(false);
      toast.error("Checkout could not be started. Please try again shortly.");
    }
  };
  return (
    <a href="#ebook" className={className} onClick={onClick} data-testid={testId} style={style} aria-busy={busy}>
      {busy ? "Opening secure checkout..." : children}
    </a>
  );
};
